function log(message: string) {
  // 本番環境以外でのみログが出力される
  //   - 開発環境: development (pnpm run dev)
  //   - STG環境: staging (pnpm build --mode staging)
  //   - 本番環境: prodction (pnpm build)
  if (import.meta.env.MODE === "production") return;
  console.log(message);
}

export default log;
